import {
  CellClassParams,
  CellDoubleClickedEvent,
  CellFocusedEvent,
  CellKeyDownEvent,
  CellStyle,
  CellValueChangedEvent,
  ColDef,
  EditableCallbackParams,
  GridOptions,
  GridReadyEvent,
  ITooltipParams,
  RowNode,
  SortChangedEvent,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import { DOCUMENT } from '@angular/common'
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core'
import { FormControl, ValidationErrors, Validators } from '@angular/forms'
import {
  EditableCheckboxRenderer,
  heliosDefaultColDef,
  heliosDefaultColWidth,
  heliosSizingAdjustments,
} from '@helios/ag-grid-config'
import { ExternalTransaction } from '@helios/common-api'
import { BlankSessionService } from '@helios/sessions'
import {
  RootState,
  selectActiveSessionReconDate,
  selectActualReconDate,
  selectFirstFocusedAccountInfo,
  selectFirstLoadedAccountId,
  selectLegacyUserId,
  selectSelectedReconDate,
  selectUserPolicy,
  UserPolicy,
} from '@helios/state-management'
import { TelemetryService } from '@helios/telemetry'
import {
  UserPreferencesService,
  WorkspaceGridSavedViewService,
} from '@helios/user-preferences'
import {
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { AgGridApi, NfTooltipParams } from '@northfork/ag-grid'
import {
  getInlineEditColumnType,
  InlineEditDataType,
} from '@northfork/ag-grid-angular'
import { ISODateFormat, parseDate } from '@northfork/basics'
import { InlineEditDisplayOptions, ToastService } from '@northfork/ng-basics'
import { isAfter } from 'date-fns'
import _ from 'lodash'
import { Observable, Subject } from 'rxjs'
import {
  debounceTime,
  filter,
  map,
  take,
  takeUntil,
  takeWhile,
} from 'rxjs/operators'
import {
  CusipRequest,
  SecurityIdRequest,
  SecurityInfo,
} from '../../../model/bulk-transaction/bulk-misc-model'
import {
  BulkTransactionModalInput,
  BulkTransactionModalMode,
} from '../../../model/bulk-transaction/bulk-popup-input-model'
import {
  BulkSleeveSimpleAccounts,
  SleeveSimple,
} from '../../../model/bulk-transaction/bulk-sleeve-simple-accounts.model'
import {
  BulkTradeEntryRow,
  SecurityInputInfoTradeKey,
  tradeField,
} from '../../../model/bulk-transaction/bulk-trade-entry/bulk-trade-entry.model'
import {
  BulkTradeEntryTransaction,
  ClearwaterTransactionDetailResponse,
  MetaDataTransaction,
  TransactionRequestWrapper,
} from '../../../model/bulk-transaction/bulk-transaction'
import { BulkTransactionRequest } from '../../../model/bulk-transaction/bulk-transaction.model'
import { BulkTradeEntryValidationView } from '../../../model/bulk-transaction/bulk-validation-view.model'
import { CounterParty } from '../../../model/counter-party.model'
import { DataMapType } from '../../../model/draw-model'
import { InventoryType } from '../../../model/inventory-type.model'
import { Security, SecurityMasterData } from '../../../model/security.model'
import { AccountInfo } from '../../../model/single-transaction/account-details.model'
import { ExternalUnmatchedTransaction } from '../../../model/single-transaction/external-unmatched-transaction'
import { Transaction } from '../../../model/single-transaction/transaction'
import {
  TranCategory,
  TranCategoryUrl,
} from '../../../model/transaction-category.model'
import {
  ENTRIES,
  EXITS,
  TransactionType,
  TransactionTypeEnum,
  TransactionTypeKey,
} from '../../../model/transaction-type.model'
import {
  ErrorSeverity,
  ValidationInfo,
} from '../../../model/validation-response.model'
import { BulkDeleteService } from '../../../services/bulk-transaction/bulk-delete.service'
import { PasteService } from '../../../services/bulk-transaction/paste.service'
import { CopyService } from '../../../services/copy.service'
import { CreateEditTransactionService } from '../../../services/create-edit-transaction.service'
import { ModalFocusService } from '../../../services/modal-focus.service'
import {
  isBulkCopyModal,
  isBulkEditModal,
  isBulkExternalModal,
} from '../../../util/bulk-popup-input-utils'
import {
  BULK_DIALOG_EVENT_NAME,
  bulkMetricsDetail,
  bulkRequestMode,
  customSortComparatorBulk,
  customSortComparatorBulkNumeric,
  customSortComparatorBulkValidatorColumn,
  fillHandleDoubleClickHandler,
  getAccountCellParams,
  isEmptyRow,
  numberValueFormatter,
  onSortChange,
  showOrderIDColumn,
  showTranIdColumn,
} from '../../../util/bulk-specific-common-utils'
import {
  mapBulkExternalTransaction,
  mapTradeToBulkTransaction,
} from '../../../util/bulk-transaction-wrapper-util'
import { Calculators } from '../../../util/calculators.util'
import {
  activateDialog,
  calculateDiscount,
  deduceValidityStatusCellClass,
  emptySelectedCellsOnValidKeyPress,
  getBuyTypes,
  getDefaultUnknownCounterParty,
  getFieldValidatorFormatter,
  getTradeTypes,
  getTransactionTypeCodeFromKey,
  getTransactionTypeKeyFromCode,
  getTransactionTypeNameFromCode,
  getValidInventory,
  isDialogComponentInActive,
  markRowsMissingAccount,
  TransactionType_FOR_SHORT,
} from '../../../util/common-utils'
import { TransactionConstants } from '../../../util/constants'
import {
  createBulkTradeEntryLoanFieldColumns,
  getLoanFieldValues,
} from '../../../util/loan-field.util'
import { BulkTransactionModalResponse } from '../bulk-transaction-modal-response'
import { BulkTransactionsSaveConfirmationModalComponent } from '../bulk-transactions-confirm-button-modal/bulk-transactions-confirm-button-modal.component'
import { ErrorTooltipComponent } from '../error-Tooltip/error-tooltip.component'

@Component({
  selector: 'hs-bulk-trade-entry',
  templateUrl: './bulk-trade-entry.component.html',
  styleUrls: ['./bulk-trade-entry.component.scss'],
  providers: [PasteService, CopyService, BulkDeleteService],
})
export class BulkTradeEntryModalComponent implements OnInit, OnDestroy {
  @Input() transInput?: BulkTransactionModalInput

  private readonly onPasteEndBinding = this.onPasteEnd.bind(this)
  private readonly adjustTransactionsPostDeleteBinding =
    this.adjustTransactionsPostDelete.bind(this)

  title = 'Trade Entry Bulk Create'
  loadingDialog = false
  loadingCounterParty = true
  getFieldValidatorFormatter = getFieldValidatorFormatter
  formSubmitting = false
  allDataValidated = false
  transactionLoaded = false
  private readonly destroySubject$ = new Subject<void>()
  securities: Map<string, Security> = new Map<string, Security>()
  accountHplMap: Map<number, boolean> = new Map<number, boolean>()
  editSecurityIdToCusipMap: Map<number, string> = new Map<number, string>()
  disableValidate = true
  lastPastedRowIds: string[] = []
  lastColumnIdsPasted: Set<string> = new Set<string>()
  missingTranRowList: Set<string> = new Set<string>()
  rowData: BulkTradeEntryRow[] = []
  transTypes = getTradeTypes().sort((a: TransactionType, b: TransactionType) =>
    a.name.localeCompare(b.name),
  )
  buyTypes = getBuyTypes().sort((a: DataMapType, b: DataMapType) =>
    a.name.localeCompare(b.name),
  )
  sortable = false
  colDefs: ColDef[] = this.getColDefs()
  gridOptions: GridOptions = this.createGridOptions()
  cellLevelErrorMessageMap = new Map<string, string[]>()
  cellLevelWarningMessageMap = new Map<string, string[]>()
  userId?: number
  hasDeveloperAccess = false

  note = new FormControl('')
  pastePostProcessingInProgress = false
  deletePostProcessingInProgress = false
  reconDate?: Date
  sessionReconDate?: Date
  selectedReconDate?: Date
  isDataValid = false
  isCommonValidationError = false
  disableSaveValidRows = false
  isValidating = false
  counterPartyList: CounterParty[] = []
  errorFields: string[] = []
  gridApi?: AgGridApi
  noteWarning: ValidationErrors | null = null
  currentNoteError: ValidationErrors | null =
    TransactionConstants.DEFAULT_NOTE_VALIDATION_ERROR
  genericErrors: string[] = []
  genericWarnings: string[] = []
  hasTransactionMatchCustody = false
  hasTransactionMatchTrading = false
  isCollateralMap: { [key: number]: boolean } = {}
  currentCounterParty?: CounterParty
  currentRowIndex = 0
  disableClear = false
  isEdit = false
  originalTransactions: BulkTradeEntryTransaction[] = []
  externalTransaction: ExternalTransaction[] = []
  bulkExternalTransactionDetail: ExternalUnmatchedTransaction[] = []
  securityMasterData: Map<string, SecurityMasterData> = new Map<
    string,
    SecurityMasterData
  >()
  clearwaterTransactionDetail: { [s: string]: Transaction } = {}
  sessionAccountInfo?: AccountInfo
  bulkSleeveSimpleAccount: BulkSleeveSimpleAccounts[] = []
  sleeveSimpleAccount: SleeveSimple[] = []
  sleeveAccountIds: number[] = []
  loadingText = TransactionConstants.LOAD_TRANSACTION
  errorText = ''
  errorHeader: string | undefined
  errorDetails: unknown

  activeInstances: NgbModalRef[] = []
  compId = 'bulk-trade-' + Math.random()
  reprocessTransfers = new FormControl(false)
  showConfirmButtonModal = false

  constructor(
    public toastService: ToastService,
    readonly activeModal: NgbActiveModal,
    readonly modalService: NgbModal,
    readonly store: Store<RootState>,
    readonly bulkTransactionService: CreateEditTransactionService,
    private readonly savedViewService: WorkspaceGridSavedViewService,
    private readonly pasteService: PasteService,
    private readonly copyService: CopyService,
    private readonly bulkDeleteService: BulkDeleteService,
    private readonly blankSessionService: BlankSessionService,
    private readonly userPreferencesService: UserPreferencesService,
    private readonly telemetryService: TelemetryService,
    private readonly elRef: ElementRef,
    private readonly modalFocusService: ModalFocusService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {
    this.userPreferencesService
      .getBulkDialogSortPromptPreference()
      .pipe(take(1), takeUntil(this.destroySubject$))
      .subscribe(sortable => {
        this.sortable = sortable
        if (this.gridOptions.defaultColDef) {
          this.gridOptions.defaultColDef.sortable = sortable
          this.gridOptions.defaultColDef.comparator = customSortComparatorBulk
        }
      })
    this.store
      .select(selectUserPolicy)
      .pipe(
        takeUntil(this.destroySubject$),
        takeWhile(userPolicy => userPolicy == null, true),
        filter((userPolicy): userPolicy is UserPolicy => userPolicy != null),
        map(userPolicy => userPolicy.accessDeveloperTools ?? false),
      )
      .subscribe(userPolicy => {
        this.hasDeveloperAccess = userPolicy
      })
    this.modalService.activeInstances
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(activeInstances => {
        this.activeInstances = activeInstances
      })
  }

  async ngOnInit() {
    const startTime = Date.now()

    activateDialog(this.activeInstances, this.compId, this.elRef)

    this.modalFocusService
      .outsideFocus(this.elRef)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(() => this.disableGridFocus())

    this.note.valueChanges
      .pipe(debounceTime(500), takeUntil(this.destroySubject$))
      .subscribe(() => {
        this.setNoteErrors()
      })
    if (this.transInput) {
      showTranIdColumn(this.gridOptions, this.transInput, this.sortable)
      if (
        isBulkEditModal(this.transInput) &&
        this.transInput.transactions?.[0].orderId
      ) {
        showOrderIDColumn(this.gridOptions, this.sortable)
      }
    }
    try {
      await this.init()
    } catch (error) {
      this.errorText = TransactionConstants.ERROR_LOADING_TRANSACTION
      this.errorDetails = error.error
    }
    this.note.markAsTouched()
    this.note.setErrors(this.currentNoteError)
    const now = Date.now()

    const [count, type] = bulkMetricsDetail(
      this.rowData.length,
      this.transInput,
    )
    this.telemetryService.emitCustomEvent(BULK_DIALOG_EVENT_NAME, {
      dialogName: 'Trade-' + type,
      durationMs: now - startTime,
      tranCount: count,
    })
  }

  private async init() {
    this.loadingDialog = true
    this.document.addEventListener('pasteDone', this.onPasteEndBinding)
    this.document.addEventListener(
      'deleteSuccessful',
      this.adjustTransactionsPostDeleteBinding,
    )
    this.loadStoreData()
    this.bulkTransactionService
      .loadCounterParties()
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(counterParties => {
        this.counterPartyList = counterParties
        this.loadingCounterParty = false
      })

    if (this.transInput?.extTranId) {
      await this.loadExtTransactionDetailBulk(this.transInput.extTranId)
    }
    if (this.transInput?.cwTranId) {
      const securityData = this.transInput.securityData?.map(
        (secData: SecurityInfo, index: number) => {
          return {
            id: index + 1,
            securityId: secData.securityId,
            date: secData.settleDate,
            accountId: secData.accountId,
          } as SecurityIdRequest
        },
      )
      await this.loadTransactionDetailBulk(
        this.transInput?.cwTranId,
        securityData,
      )
    }
    if (this.transInput?.bulkStatus) {
      this.transInput.externalTransaction = mapBulkExternalTransaction(
        this.bulkExternalTransactionDetail,
        this.transInput.bulkStatus,
      )
    }
    if (this.transInput?.cwTranId) {
      this.transInput.transactions = mapTradeToBulkTransaction(
        this.clearwaterTransactionDetail,
      )
    }

    if (
      !isBulkCopyModal(this.transInput) &&
      (this.transInput?.transactions || this.transInput?.externalTransaction)
    ) {
      this.missingTranRowList.clear()
      this.title = 'Trade Entry Bulk Edit'
      this.disableValidate = false
      this.disableClear = true
      this.isEdit = true
      this.pasteService.setIsEdit()

      if (isBulkEditModal(this.transInput)) {
        this.originalTransactions = this.transInput
          ?.transactions as BulkTradeEntryTransaction[]

        const tradeTransactions = this.transInput
          ?.transactions as BulkTradeEntryTransaction[]
        this.loadCollateralOnEdit(
          new Set(
            this.originalTransactions.map(origTran => origTran.accountId),
          ),
        )
        if (!this.transInput?.cwTranId) {
          const securityIdRequests: SecurityIdRequest[] = []
          const setOfSecurityInputs = new Set<string>()

          tradeTransactions.forEach((transactionTrade, index) => {
            const securityAssetKey = JSON.stringify({
              securityId: transactionTrade.securityId ?? 0,
              settleDate: transactionTrade.settleDate,
            })
            if (!setOfSecurityInputs.has(securityAssetKey)) {
              setOfSecurityInputs.add(
                JSON.stringify({
                  securityId: transactionTrade.securityId ?? 0,
                  settleDate: transactionTrade.settleDate,
                }),
              )
              const securityInputInfoTradeEdit = JSON.parse(securityAssetKey)
              securityIdRequests.push({
                id: index + 1,
                securityId: securityInputInfoTradeEdit.securityId,
                date: securityInputInfoTradeEdit.settleDate,
                accountId: transactionTrade.accountId,
              })
            }
          })
          if (securityIdRequests.length > 0) {
            await this.loadSecurityDataForSecurity(securityIdRequests)
          }
        }
        tradeTransactions.forEach((CwanTrade, index) => {
          const currentSecurityInputInfoTrade: SecurityInputInfoTradeKey = {
            cusip:
              this.editSecurityIdToCusipMap.get(CwanTrade.securityId ?? 0) ??
              '',
            settleDate: CwanTrade.settleDate,
          }
          if (
            CwanTrade.counterParty &&
            !this.counterPartyList.find(
              cp => cp.name == CwanTrade.counterParty?.name,
            )
          ) {
            this.counterPartyList.push(CwanTrade.counterParty)
          }
          this.rowData.push(
            this.generateDataEntryFromTrade(
              CwanTrade,
              index,
              this.getSecurityDetailsByAssetIdAndSettleDate(
                JSON.stringify(currentSecurityInputInfoTrade),
              ),
            ),
          )
        })
      } else if (isBulkExternalModal(this.transInput)) {
        this.externalTransaction = this.transInput
          ?.externalTransaction as ExternalTransaction[]
        if (!this.transInput?.extTranId) {
          const uniqueAccountIdExternal = [
            ...new Set(this.externalTransaction.map(obj => obj.accountId)),
          ]
          await this.loadNonSessionAccountTypeInfo(uniqueAccountIdExternal)
        }
        this.externalTransaction.forEach((CwanTrade, index) => {
          if (
            CwanTrade.clearwaterCounterParty &&
            !this.counterPartyList.find(
              cp => cp.name == CwanTrade.clearwaterCounterParty?.name,
            )
          ) {
            this.counterPartyList.push(CwanTrade.clearwaterCounterParty)
          }
          this.rowData.push(
            this.generateDataEntryFromExternalTrade(CwanTrade, index),
          )
        })
      }
    } else if (isBulkCopyModal(this.transInput)) {
      this.disableValidate = false
      this.originalTransactions = this.transInput
        ?.transactions as BulkTradeEntryTransaction[]
      const tradeTransactions = this.transInput
        ?.transactions as BulkTradeEntryTransaction[]

      tradeTransactions.forEach((CwanTrade, index) => {
        if (
          CwanTrade.counterParty &&
          !this.counterPartyList.find(
            cp => cp.name == CwanTrade.counterParty?.name,
          )
        ) {
          this.counterPartyList.push(CwanTrade.counterParty)
        }
        this.rowData.push(
          this.generateDataEntryFromTrade(CwanTrade, index, undefined),
        )
      })
      this.rowData.push(
        this.generateEmptyDataEntry(false, this.rowData.length + 1),
      )
    } else {
      this.createFreshRowData()
    }
    this.gridApi?.api.applyTransaction({ add: this.rowData })

    this.setSleeveSimpleAccountIdsPerRow()

    this.loadingDialog = false
  }

  setSleeveSimpleAccountIdsPerRow() {
    if (this.bulkSleeveSimpleAccount.length > 0)
      this.rowData.forEach(node => {
        node.sleeveSimpleAccountIds = this.bulkSleeveSimpleAccount
          .filter(
            sleeveSimpleId =>
              sleeveSimpleId.id === Number(node.externalAccountId),
          )
          .map(data => data.sleeveSimple)[0]
      })
    else
      this.rowData.forEach(
        node => (node.sleeveSimpleAccountIds = this.sleeveSimpleAccount),
      )
  }

  ngOnDestroy(): void {
    this.pasteService.destroy()
    this.copyService.destroy()
    this.destroySubject$.next()
    this.destroySubject$.complete()

    this.document.removeEventListener('pasteDone', this.onPasteEndBinding)
    this.document.removeEventListener(
      'deleteSuccessful',
      this.adjustTransactionsPostDeleteBinding,
    )
  }

  /** @internal */
  loadStoreData() {
    this.store
      .select(selectActualReconDate)
      .pipe(take(1), takeUntil(this.destroySubject$))
      .subscribe((reconDate?: Date) => {
        this.reconDate = reconDate
      })
    this.store
      .select(selectActiveSessionReconDate)
      .pipe(take(1), takeUntil(this.destroySubject$))
      .subscribe((sessionReconDate?: Date) => {
        this.sessionReconDate = sessionReconDate
      })
    this.store
      .select(selectSelectedReconDate)
      .pipe(take(1), takeUntil(this.destroySubject$))
      .subscribe((selectedReconDate?: Date) => {
        this.selectedReconDate = selectedReconDate
      })
    this.store
      .select(selectLegacyUserId)
      .pipe(take(1), takeUntil(this.destroySubject$))
      .subscribe((userId?: number) => {
        this.userId = userId
      })
  }

  /** @internal */
  async loadSecurityDataForSecurity(securityIDRequests: SecurityIdRequest[]) {
    const CHUNK_SIZE = 5000

    const chunkedSecurities$ = _.chunk(securityIDRequests, CHUNK_SIZE).map(
      s => {
        return this.loadSecuritiesUsingSecurityIds(s)
      },
    )

    const securities = (await Promise.all(chunkedSecurities$)).reduce(
      (acc, curr) => {
        return { ...acc, ...curr }
      },
    )

    const securitiesEntries = new Map<string, Security>(
      Object.entries(securities),
    )
    securitiesEntries.forEach((security, index) => {
      this.securities.set(
        JSON.stringify({
          cusip: security.securityMasterData.cusip,
          settleDate: securityIDRequests.find(
            secReq => secReq.id == Number(index),
          )?.date,
        }),
        security,
      )
      this.editSecurityIdToCusipMap.set(
        security.securityMasterData.id,
        security.securityMasterData.cusip,
      )
    })
  }

  /** @internal */
  async loadSecuritiesUsingSecurityIds(
    securityIdRequests: SecurityIdRequest[],
  ) {
    const securityIdsPromise =
      this.bulkTransactionService.fetchSecurityDetailsFromSecurityIds(
        securityIdRequests,
      )
    return securityIdsPromise.toPromise()
  }

  /** @internal */
  async loadExternalData(
    assetIdSettleDateMap: CusipRequest[],
    accountSet: Set<number>,
  ) {
    if (assetIdSettleDateMap.length > 0) {
      this.loadingDialog = true
      this.loadingText = TransactionConstants.LOAD_SECURITY_INFORMATION
      await this.loadSecurityData(assetIdSettleDateMap)
    }

    if (accountSet.size > 0) {
      this.loadingDialog = true
      this.loadingText = TransactionConstants.LOAD_HPL_INFO_BULK
      await this.loadHplStatus(Array.from(accountSet))
    }
    this.loadingDialog = false
  }

  async loadHplStatus(accounts: number[]) {
    const hplStatusByAccount = await this.bulkTransactionService
      .getIsHplAccounts(accounts)
      .toPromise()
    Object.entries(hplStatusByAccount).forEach(([key, value]) => {
      // Convert the string key to a number and set it in the Map
      this.accountHplMap.set(Number(key), value)
    })
  }

  async loadSecurityData(assetIdSettleDateMap: CusipRequest[]) {
    const assetIds = await this.bulkTransactionService
      .fetchSecurityDetailsFromCusips(assetIdSettleDateMap)
      .toPromise()
    if (assetIds) {
      const securitiesEntries = new Map<string, Security>(
        Object.entries(assetIds),
      )
      securitiesEntries.forEach((security, index) => {
        this.securities.set(
          JSON.stringify({
            cusip: security.securityMasterData.cusip,
            settleDate: assetIdSettleDateMap.find(
              cusipReq => cusipReq.id == Number(index),
            )?.date,
          }),
          security,
        )
      })
    }
  }

  setNoteErrors() {
    if (this.currentNoteError != null) {
      this.note.setErrors(this.currentNoteError)
    }
  }

  async onGridReady(event: GridReadyEvent) {
    this.gridApi = event
    this.pasteService.registerGrid(event.api, event.columnApi)
    this.copyService.registerGrid(event.api)
    this.bulkDeleteService.registerGrid(event.api)
    await this.savedViewService.manageSavedView(
      event,
      'Bulk-trade-entry-workspace-key',
      this.destroySubject$,
    )
    this.gridApi.api.setSortModel(null)
  }

  private createGridOptions(): GridOptions {
    return {
      ...heliosSizingAdjustments,
      onGridReady: event => this.onGridReady(event),
      getRowNodeId: ({ rowId }: BulkTradeEntryRow) => rowId,
      rowSelection: 'multiple',
      onCellDoubleClicked: (event: CellDoubleClickedEvent) => {
        const element = event.event?.target as HTMLElement
        if (element.className == 'ag-fill-handle') {
          fillHandleDoubleClickHandler(event.api)
        } else {
          event.api.startEditingCell({
            rowIndex: this.currentRowIndex,
            colKey: event.column.getColId(),
          })
        }
      },

      onCellKeyDown: (event: CellKeyDownEvent) => {
        if (event.api.getEditingCells().length == 0) {
          emptySelectedCellsOnValidKeyPress(
            (event.event as KeyboardEvent).key,
            event.api,
          )
        }
      },
      suppressMultiRangeSelection: false,
      defaultColDef: {
        ...heliosDefaultColDef,
        menuTabs: [],
        minWidth: heliosDefaultColWidth.ValidityStatusCol,
        sortable: false,
      },
      sideBar: false,
      enableFillHandle: true,
      getContextMenuItems: () => this.getContextMenuItems(),
      enableCellChangeFlash: true,
      enableRangeSelection: true,
      onSortChanged: (params: SortChangedEvent) => onSortChange(params),
      columnDefs: this.colDefs,
      onCellValueChanged: (event: CellValueChangedEvent) => {
        this.onColumnValueChanged(event)
      },
      onCellFocused: (event: CellFocusedEvent) => {
        this.handleCellFocus(event)
      },
    }
  }

  private getColDefs(): ColDef[] {
    return [
      {
        field: tradeField('validityStatus'),
        headerName: '',
        valueGetter: () => '',
        cellClass: params =>
          deduceValidityStatusCellClass(params.data.validityStatus),
        tooltipField: 'errorMessageMap',
        tooltipComponentParams: {
          showTooltip: params =>
            params?.data.errorMessageMap &&
            params.data.errorMessageMap.size > 0,
        } as NfTooltipParams,
        width: heliosDefaultColWidth.ValidityStatusCol,
        tooltipComponent: ErrorTooltipComponent,
        comparator: customSortComparatorBulkValidatorColumn,
      },
      {
        field: tradeField('rowNumber'),
        sortable: false,
        headerName: '#',
        valueGetter: 'node.rowIndex + 1',
        width: heliosDefaultColWidth.SerialNumberCol,
      },
      {
        field: tradeField('errorMessageMap'),
        hide: true,
      },
      {
        field: tradeField('accountId'),
        headerName: 'Account ID',
        type: getInlineEditColumnType(),
        width: 85,
        cellEditorSelector: (x: EditableCallbackParams) =>
          getAccountCellParams(
            x,
            !!this.transInput?.externalTransaction,
            this.sessionAccountInfo?.accountType,
          ),
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,

        editable: (x: EditableCallbackParams) => this.isAccountEditable(x),
      },
      {
        field: tradeField('tranType'),
        width: 150,
        headerName: 'Transaction Type*',
        type: getInlineEditColumnType(),
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        cellEditorParams: {
          validators: [Validators.required],
          dataType: InlineEditDataType.Select,
          options: {
            items: this.transTypes,
            bindLabel: 'code',
            bindValue: 'code',
          },
        },
        cellStyle: params => this.deduceTranTypeCellStyle(params),
        tooltipValueGetter: params => this.deduceTranTypeToolTip(params),
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('assetId'),
        headerName: 'Asset ID',
        width: 115,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.String,
          disablePopover: true,
        },
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
        editable: () => !isBulkEditModal(this.transInput),
      },

      {
        field: tradeField('entryDate'),
        headerName: 'Entry Date',
        width: 100,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Date,
        },
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('settleDate'),
        headerName: 'Settle Date',
        width: 100,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Date,
        },
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('postDate'),
        headerName: 'Post Date',
        width: 100,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Date,
        },
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('price'),
        headerName: 'Price',
        width: 115,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Number,
          disablePopover: true,
        },
        valueFormatter: (params: ValueFormatterParams) =>
          params.value !== ''
            ? numberValueFormatter(Number(params.value), 2, 4)
            : '',
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        comparator: customSortComparatorBulkNumeric,
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('units'),
        headerName: 'Units',
        width: 115,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Number,
          disablePopover: true,
        },
        comparator: customSortComparatorBulkNumeric,
        valueFormatter: (params: ValueFormatterParams) =>
          params.value !== ''
            ? numberValueFormatter(Number(params.value), 2, 4)
            : '',
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('commission'),
        headerName: 'Commission',
        width: 90,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Number,
          disablePopover: true,
        },
        comparator: customSortComparatorBulkNumeric,
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        valueFormatter: (params: ValueFormatterParams) =>
          params.value !== ''
            ? numberValueFormatter(Number(params.value), 2, 2)
            : '',
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('factor'),
        headerName: 'Factor',
        width: 70,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Number,
          disablePopover: true,
        },
        comparator: customSortComparatorBulkNumeric,
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('dollarAccrued'),
        headerName: 'Dollar Accrued',
        width: 150,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Number,
          disablePopover: true,
        },
        comparator: customSortComparatorBulkNumeric,
        valueFormatter: (params: ValueFormatterParams) =>
          params.value !== ''
            ? numberValueFormatter(Number(params.value), 2, 2)
            : '',
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
        editable: (params: EditableCallbackParams) =>
          !this.isCurrentRowFutureSecured(params.data),
      },
      {
        field: tradeField('proceeds'),
        headerName: 'Proceeds',
        width: 120,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Number,
          disablePopover: true,
        },
        comparator: customSortComparatorBulkNumeric,
        valueFormatter: (params: ValueFormatterParams) =>
          params.value !== ''
            ? numberValueFormatter(Number(params.value), 2, 4)
            : '',
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
        editable: false,
      },
      {
        field: tradeField('inventoryType'),
        headerName: 'Inventory Type',
        width: 115,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Select,
          options: {
            items: Object.keys(InventoryType),
          },
        },
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('counterParty'),
        headerName: 'Counter Party',
        width: 195,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.String,

          disablePopover: true,
        },
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('originationFee'),
        headerName: 'Loan Origination Fee',
        width: 90,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Number,
          disablePopover: true,
        },
        comparator: customSortComparatorBulkNumeric,
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        valueFormatter: (params: ValueFormatterParams) =>
          params.value !== ''
            ? numberValueFormatter(Number(params.value), 2, 2)
            : '',
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('exitFee'),
        headerValueGetter: 'Loan Exit Fee Unaccrued',
        width: 90,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Number,
          disablePopover: true,
        },
        comparator: customSortComparatorBulkNumeric,
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        valueFormatter: (params: ValueFormatterParams) =>
          params.value !== ''
            ? numberValueFormatter(Number(params.value), 2, 2)
            : '',
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('exitFeeReceivable'),
        headerName: 'Loan Exit Fee Receivable',
        width: 90,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Number,
          disablePopover: true,
        },
        comparator: customSortComparatorBulkNumeric,
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        valueFormatter: (params: ValueFormatterParams) =>
          params.value !== ''
            ? numberValueFormatter(Number(params.value), 2, 2)
            : '',
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('drawFee'),
        headerName: 'Loan Draw Fee',
        width: 90,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Number,
          disablePopover: true,
        },
        comparator: customSortComparatorBulkNumeric,
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        valueFormatter: (params: ValueFormatterParams) =>
          params.value !== ''
            ? numberValueFormatter(Number(params.value), 2, 2)
            : '',
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('prepaymentPenaltyFee'),
        headerName: 'Loan Prepayment Penalty Fee',
        width: 90,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Number,
          disablePopover: true,
        },
        comparator: customSortComparatorBulkNumeric,
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        valueFormatter: (params: ValueFormatterParams) =>
          params.value !== ''
            ? numberValueFormatter(Number(params.value), 2, 2)
            : '',
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('buyType'),
        headerName: 'Buy Type',
        width: 90,
        type: getInlineEditColumnType(),
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        cellEditorParams: {
          dataType: InlineEditDataType.Select,
          options: {
            items: this.buyTypes,
            bindLabel: 'code',
            bindValue: 'code',
          },
        },
        cellStyle: params => this.deduceTranTypeCellStyle(params),
        tooltipValueGetter: params => this.deduceTranTypeToolTip(params),
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('cleared'),
        headerName: 'Cleared',
        cellRenderer: EditableCheckboxRenderer,
        width: heliosDefaultColWidth.Id,
      },
      {
        field: tradeField('collateralBroker'),
        headerName: 'Collateral Broker',
        width: 100,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.String,
          disablePopover: true,
        },
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        cellStyle: (params: CellClassParams) => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: (params: ITooltipParams) => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
        columnGroupShow: 'open',
        editable: (params: EditableCallbackParams) =>
          this.isCollateralEditable(params),
      },
      {
        field: tradeField('prepaidInterest'),
        headerName: 'Loan Prepaid Interest',
        width: 100,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Number,
          disablePopover: true,
        },
        comparator: customSortComparatorBulkNumeric,
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        valueFormatter: (params: ValueFormatterParams) =>
          params.value !== ''
            ? numberValueFormatter(Number(params.value), 2, 2)
            : '',
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      {
        field: tradeField('interestDue'),
        headerName: 'Loan Past Due Interest',
        width: 90,
        type: getInlineEditColumnType(),
        cellEditorParams: {
          dataType: InlineEditDataType.Number,
          disablePopover: true,
        },
        comparator: customSortComparatorBulkNumeric,
        cellRendererParams: {
          editButtonClickOnly: true,
        } as InlineEditDisplayOptions,
        valueFormatter: (params: ValueFormatterParams) =>
          params.value !== ''
            ? numberValueFormatter(Number(params.value), 2, 2)
            : '',
        cellStyle: params => {
          return this.getCellStyle(params)
        },
        tooltipValueGetter: params => {
          return this.toolTipValueGetter(params)
        },
        tooltipComponentParams: {
          showTooltip: params => this.showToolTip(params),
        } as NfTooltipParams,
      },
      ...createBulkTradeEntryLoanFieldColumns({
        fieldPath: tradeField,
        getCellStyle: params => this.getCellStyle(params),
        toolTipValueGetter: params => this.toolTipValueGetter(params),
        showToolTip: params => this.showToolTip(params),
      }),
      {
        field: tradeField('transactionTypeLabel'),
        hide: true,
      },
    ]
  }

  async loadCollateralOnEdit(accounts: Set<number>) {
    const collateralObservable = await this.bulkTransactionService
      .isCollateralBroker(Array.from(accounts))
      .toPromise()
    this.isCollateralMap = collateralObservable
  }

  isCollateralEditable(params: EditableCallbackParams) {
    return (
      !isBulkEditModal(this.transInput) ||
      this.isCollateralMap?.[params.data.accountId]
    )
  }

  deduceTranTypeCellStyle(params: CellClassParams) {
    if (
      params.data.tranType == '' &&
      params.data.validityStatus != 'inactive'
    ) {
      return { 'background-color': 'lightcoral' }
    } else {
      return this.getCellStyle(params)
    }
  }

  deduceTranTypeToolTip(params: ITooltipParams) {
    if (
      params.data.tranType == '' &&
      params.data.validityStatus != 'inactive'
    ) {
      return 'Valid Value Required'
    } else {
      return this.toolTipValueGetter(params)
    }
  }
  handleCellFocus(event: CellFocusedEvent) {
    this.currentRowIndex = event.rowIndex ?? 0
  }

  async onPasteEnd(evt: Event) {
    const pasteDetails = (evt as CustomEvent).detail
    this.pastePostProcessingInProgress = true
    this.disableValidate = true

    this.lastPastedRowIds = pasteDetails.pastedRowData.map(
      (rowData: { rowId: BulkTradeEntryRow }) => rowData.rowId,
    )
    this.lastColumnIdsPasted = pasteDetails.colPastedSet
    this.loadingDialog = true
    this.pastePostProcessingInProgress = false
    this.allDataValidated = false
    this.applyOnChangeForPastedRowNodes()

    if (this.missingTranRowList.size == 0) this.disableValidate = false

    this.loadingDialog = false
  }

  applyOnChangeForPastedRowNodes() {
    this.lastPastedRowIds.forEach(rowId => {
      const displayedNode = this.gridApi?.api.getRowNode(rowId)
      if (displayedNode) {
        this.applyOnChangeForPastedRowNode(displayedNode)
      }
    })
  }

  applyOnChangeForPastedRowNode(displayedNode: RowNode) {
    const allColumns = this.gridApi?.columnApi.getAllColumns()
    allColumns
      ?.filter(column =>
        this.lastColumnIdsPasted.has(column.getColDef().field ?? ''),
      )
      .forEach(currentColumn => {
        const colId = currentColumn.getColDef().field
        this.onColumnValueChanged({
          column: { getColId: () => colId },
          node: displayedNode,
          data: displayedNode.data,
          newValue: displayedNode?.data[colId ?? ''],
          oldValue: '',
        } as unknown as CellValueChangedEvent)
      })
  }

  /**
   * The right click magic
   *
   * @internal
   */
  getContextMenuItems() {
    return [
      {
        name: 'Remove Row(s)',
        tooltip: 'Remove selected row(s)',
        action: () => {
          this.bulkDeleteService.deleteHandler()
        },
      },
      'export',
      'copy',
    ]
  }

  adjustTransactionsPostDelete() {
    this.deletePostProcessingInProgress = true
    this.missingTranRowList.clear()
    this.disableValidate = true
    this.gridApi?.api.forEachNode(rowNode => {
      if (rowNode.data.validityStatus != 'inactive') {
        if (rowNode.data.tranType == '') {
          this.missingTranRowList.add(rowNode.data.rowId.toString())
        }
      }
    })
    if (this.missingTranRowList.size == 0) this.disableValidate = false
    this.deletePostProcessingInProgress = false
  }

  showToolTip(params?: ITooltipParams) {
    const impactedFieldColDef = params?.colDef as ColDef
    const impactedFieldProcessed = this.deduceImpactedField(
      impactedFieldColDef.field ?? '',
    )
    const index = params?.data.rowId
    const cellKey = `${index}-${impactedFieldProcessed}`
    const currentValidationErrors = this.cellLevelErrorMessageMap.get(cellKey)
    const currentValidationWarnings =
      this.cellLevelWarningMessageMap.get(cellKey)
    if (
      (currentValidationErrors && currentValidationErrors?.length > 0) ||
      (currentValidationWarnings && currentValidationWarnings?.length > 0) ||
      (params?.data.tranType == '' && params?.data.validityStatus != 'inactive')
    ) {
      return true
    }
    return false
  }

  toolTipValueGetter(params: ITooltipParams): string {
    const impactedFieldColDef = params.colDef as ColDef
    const impactedFieldProcessed = this.deduceImpactedField(
      impactedFieldColDef.field ?? '',
    )
    const index = params.data.rowId
    const cellKey = `${index}-${impactedFieldProcessed}`
    const currentValidationErrors = this.cellLevelErrorMessageMap.get(cellKey)
    const currentValidationWarnings =
      this.cellLevelWarningMessageMap.get(cellKey)

    if (currentValidationErrors) {
      return currentValidationErrors.join(' | ')
    } else if (currentValidationWarnings) {
      return currentValidationWarnings.join(' | ')
    } else {
      return impactedFieldColDef?.field == 'counterParty' ? params.value : ''
    }
  }
  deduceImpactedField(impactedFieldFromValidationInfo: string): string {
    if (impactedFieldFromValidationInfo == 'securityId') {
      return 'assetId'
    } else if (impactedFieldFromValidationInfo == 'amount') {
      return 'proceeds'
    } else {
      return impactedFieldFromValidationInfo
    }
  }
  getCellStyle(params: CellClassParams): CellStyle {
    const impactedFieldProcessed = this.deduceImpactedField(
      params.colDef.field ?? '',
    )
    const index = params.data.rowId
    const cellKey = `${index}-${impactedFieldProcessed}`
    if (this.cellLevelErrorMessageMap.has(cellKey)) {
      return { 'background-color': 'lightcoral' }
    } else if (this.cellLevelWarningMessageMap.has(cellKey)) {
      return { 'background-color': 'yellow' }
    } else {
      return { 'background-color': '#00000000' }
    }
  }

  onColumnValueChanged(event: CellValueChangedEvent) {
    const rowNode = event.node
    const colId = event.column.getColId()
    if (
      rowNode.data[colId] === event.oldValue ||
      this.deletePostProcessingInProgress ||
      this.pastePostProcessingInProgress
    ) {
      return
    }
    if (
      (this.transInput?.modalMode == BulkTransactionModalMode.CreateCWTran ||
        this.transInput?.modalMode == BulkTransactionModalMode.CopyCWTran) &&
      colId != 'validityStatus' &&
      colId != 'errorMessageMap'
    ) {
      if (rowNode?.data.validityStatus == 'inactive') {
        if (colId != 'tranType') {
          const tranTypeMap = new Map<string, string[]>()
          tranTypeMap.set('tranType', ['Valid Value Required'])
          rowNode.data.errorMessageMap = tranTypeMap
          rowNode.setDataValue('validityStatus', 'invalid')
          this.disableValidate = true
          rowNode.setData(rowNode.data)
        }

        if (
          Number(rowNode?.rowIndex) + 1 ==
          this.gridApi?.api.getDisplayedRowCount()
        ) {
          const rows = [
            this.generateEmptyDataEntry(false, Number(rowNode.data.rowId) + 1),
          ]
          this.gridApi?.api.applyTransaction({ add: rows })
        }
      } else {
        if (
          isEmptyRow(rowNode, [
            'validityStatus',
            'rowId',
            'cleared',
            'errorMessageMap',
            'sleeveSimpleAccountIds',
          ])
        ) {
          rowNode.setDataValue('validityStatus', 'inactive')
          rowNode.data.errorMessageMap = new Map()
          rowNode.setData(rowNode.data)
          this.missingTranRowList.delete(rowNode.data.rowId)
          if (this.missingTranRowList.size == 0) this.disableValidate = false
        }
      }
    }

    if (
      rowNode.data.tranType != '' &&
      colId != 'validityStatus' &&
      colId != 'errorMessageMap' &&
      rowNode.data.validityStatus != 'intermediate'
    ) {
      rowNode.setDataValue('validityStatus', 'intermediate')
      rowNode.setData(rowNode.data)
      this.allDataValidated = false
    }

    switch (colId) {
      case 'tranType':
        this.adjustForTransactionTypeChange(event)
        break
      case 'validityStatus':
        this.onValidityStatusChanged(event)
        break
      case 'postDate':
        this.clearUnclearTransaction(event)
        break
      case 'accountId':
        if (this.bulkSleeveSimpleAccount.length > 0) {
          this.sleeveSimpleAccount = this.bulkSleeveSimpleAccount
            .filter(
              data => data.id === Number(event.node.data['externalAccountId']),
            )
            .map(data => data.sleeveSimple)[0]
        }
        if (this.sleeveSimpleAccount && this.sleeveSimpleAccount.length > 0) {
          const sAccount = this.sleeveSimpleAccount?.filter(
            data => data.displayLabel == event.node.data['accountId'],
          )[0]?.id
          if (sAccount) {
            event.node.data['sleeveAccountId'] = sAccount
          } else {
            rowNode.setDataValue('accountId', '')
          }
        }
    }
  }

  clearUnclearTransaction(event: CellValueChangedEvent) {
    if (isBulkEditModal(this.transInput)) return

    const postDate = event.node.data['postDate']
    if (
      this.reconDate &&
      !isAfter(parseDate(postDate, ISODateFormat), this.reconDate)
    ) {
      event.node.setDataValue('cleared', true)
    } else event.node.setDataValue('cleared', false)
  }

  isCurrentRowFutureSecured(data: BulkTradeEntryRow) {
    const security = this.getSecurityDetailsByAssetIdAndSettleDate(
      JSON.stringify({
        cusip: data.assetId,
        settleDate: data.settleDate,
      }),
    )
    return security?.securityTypeData?.isFuture
  }

  updateFactor(rowData: BulkTradeEntryRow, security?: Security) {
    if (security && rowData.factor === '') {
      rowData.factor = security.securityTypeData?.isBond
        ? Calculators.calculateCombinedFactor(security).toString()
        : '1.0'
    }
  }

  onValidityStatusChanged(event: CellValueChangedEvent) {
    if (
      event.node.data.tranType == '' &&
      event.node.data.validityStatus == 'invalid'
    ) {
      this.missingTranRowList.add(event.node.data.rowId)
      this.disableValidate = true
    }
  }
  adjustInventoryType(event: CellValueChangedEvent) {
    if (event.node.data['inventoryType'] !== '') {
      if (
        TransactionType_FOR_SHORT.includes(
          getTransactionTypeNameFromCode(event.node.data['tranType']),
        )
      ) {
        event.node.setDataValue('inventoryType', 'SHORT')
      } else if (
        getTransactionTypeNameFromCode(event.node.data['tranType']) ==
        TransactionTypeEnum.OPTION_WRITE
      ) {
        event.node.setDataValue('inventoryType', 'ISSUE')
      } else {
        event.node.setDataValue('inventoryType', 'LONG')
      }
    }
  }

  calculateAndUpdateDollarAccrued(
    data: BulkTradeEntryRow,
    security?: Security,
  ) {
    if (data.dollarAccrued != '') {
      return
    }
    const accruedInterest = security?.decimalAccrued

    const units = data['units']
    const factor = data['factor']

    const dollarAccrued = security
      ? Calculators.calculateAccruedAmount(
          security,
          Number(accruedInterest),
          Number(units),
          Number(factor),
        )
      : 0

    data.dollarAccrued = dollarAccrued.toString()
  }

  private calculateProceeds(
    data: BulkTradeEntryRow,
    security?: Security,
  ): number {
    const price = Number(data.price)
    const commission = Number(data.commission)
    const originationFee = Number(data.originationFee)
    const drawFee = Number(data.drawFee)
    const exitFee = Number(data.exitFee ?? 0)
    const exitFeeReceivable = Number(data.exitFeeReceivable ?? 0)
    const prepaymentPenaltyFee = Number(data.prepaymentPenaltyFee)
    const prepaidInterest = Number(data.prepaidInterest)
    const interestDue = Number(data.interestDue)
    const reserveTotal =
      Number(data.interestBearingInterestReserve ?? 0) +
      Number(data.interestBearingPrincipalReserve ?? 0) +
      Number(data.nonInterestBearingInterestReserve ?? 0) +
      Number(data.nonInterestBearingPrincipalReserve ?? 0)
    const units = Number(data.units)
    const factor = Number(data.factor)
    const dollarAccrued = Number(data.dollarAccrued)
    const isHplAccount = data.accountId
      ? this.accountHplMap.get(Number(data.accountId))
      : false
    const inventoryTypeKey: string = data.inventoryType ?? 'LONG'
    const transactionType: TransactionTypeEnum = getTransactionTypeNameFromCode(
      data.tranType,
    )
    let proceedValue = 0.0
    const accruedInterest = security
      ? Calculators.calculateAccruedInterest(
          security,
          dollarAccrued,
          units,
          factor,
          Boolean(isHplAccount),
        )
      : 0.0
    if (!security) {
      proceedValue = Calculators.calculateProceedsWithAssumptions(
        Number(price),
        accruedInterest,
        units,
        commission,
        originationFee,
        drawFee,
        exitFee,
        exitFeeReceivable,
        prepaymentPenaltyFee,
        prepaidInterest,
        interestDue,
        reserveTotal,
        factor,
        Boolean(isHplAccount),
      )
    } else {
      proceedValue = Calculators.calculateProceeds(
        Number(price),
        accruedInterest,
        units,
        commission,
        originationFee,
        drawFee,
        exitFee,
        exitFeeReceivable,
        prepaymentPenaltyFee,
        prepaidInterest,
        interestDue,
        reserveTotal,
        security,
        transactionType,
        factor,
        Boolean(isHplAccount),
        inventoryTypeKey,
      )
    }
    return proceedValue
  }

  private adjustForTransactionTypeChange(event: CellValueChangedEvent) {
    this.missingTranRowList.delete(event.node.data.rowId)
    if (this.missingTranRowList.size == 0) this.disableValidate = false
    this.adjustInventoryType(event)
  }

  updateUnits(data: BulkTradeEntryRow) {
    const transType = getTransactionTypeKeyFromCode(data['tranType'])
    let inventoryType = data['inventoryType']
    if (!inventoryType) inventoryType = getValidInventory(transType)
    if (
      ENTRIES.includes(TransactionTypeEnum[transType]) &&
      EXITS.includes(TransactionTypeEnum[transType])
    ) {
      this.adjustPositiveUnits(data)
    } else if (ENTRIES.includes(TransactionTypeEnum[transType])) {
      if (inventoryType === 'LONG' || inventoryType === 'Long Position') {
        this.adjustPositiveUnits(data)
      } else if (
        inventoryType === 'SHORT' ||
        inventoryType === 'Short Position'
      ) {
        this.adjustNegativeUnits(data)
      }
    } else if (EXITS.includes(TransactionTypeEnum[transType])) {
      if (inventoryType === 'LONG' || inventoryType === 'Long Position') {
        this.adjustNegativeUnits(data)
      } else if (
        inventoryType === 'SHORT' ||
        inventoryType === 'Short Position'
      ) {
        this.adjustPositiveUnits(data)
      }
    }
  }

  adjustNegativeUnits(data: BulkTradeEntryRow) {
    if (data['units'] !== '' && Number(data['units']) > 0) {
      data.units = (-1 * Math.abs(Number(data['units']))).toString()
    }
  }

  adjustPositiveUnits(data: BulkTradeEntryRow) {
    if (data['units'] !== '' && Number(data['units']) < 0) {
      data.units = Math.abs(Number(data['units'])).toString()
    }
  }

  disableSaveValidRowsButton() {
    let disable = true

    this.gridApi?.api.forEachNode(node => {
      if (
        node.data.validityStatus == 'valid' ||
        node.data.validityStatus == 'warning'
      ) {
        disable = false // If at least one node has validity 'valid' or 'warning', set disable to false
        return // Exit the loop early if validity is 'valid'
      }
    })

    // Set disableSaveValidRows based on the value of disable
    this.disableSaveValidRows = disable
  }

  async deriveAndValidate() {
    if (this.markMissingAccountRows()) {
      return
    }
    await this.deriveCwData()
    this.validate()
  }
  // Flags active rows with no account as invalid client-side so the user gets an
  // inline "Account is required" error on the cell instead of a silently disabled
  // Validate button. Returns true if any row was missing an account, in which case
  // validate() short-circuits and never sends accountId 0 to the backend.
  markMissingAccountRows(): boolean {
    const anyMissing = markRowsMissingAccount(
      this.gridApi?.api,
      'accountId',
      this.deduceImpactedField('accountId'),
      this.cellLevelErrorMessageMap,
    )
    if (anyMissing) {
      this.isDataValid = false
    }
    return anyMissing
  }

  async validate() {
    this.gridApi?.api?.clearRangeSelection()
    this.isDataValid = true
    this.isCommonValidationError = false
    this.errorDetails = ''
    if (this.markMissingAccountRows()) {
      return
    }
    const bulkValidateView = this.createBulkValidationView()
    this.isValidating = true
    try {
      this.loadingText = TransactionConstants.VALIDATE_TRANSACTION
      const validationInfos = await this.bulkTransactionService
        .validateBulkTransaction(bulkValidateView, TranCategoryUrl.TRADE_ENTRY)
        .toPromise()
      this.handleBulkValidationResponse(validationInfos.validationMap)
      this.handleCommonValidations(validationInfos.commonValidations)
      this.allDataValidated = true
      this.disableSaveValidRowsButton()
      this.isValidating = false
    } catch (error) {
      this.errorHeader = TransactionConstants.VALIDATION_ERROR
      this.errorDetails = error.error
      this.isValidating = false
    }
  }
  async deriveCwData() {
    const assetIdSettleDateMap: CusipRequest[] = []
    const accountSet = new Set<number>()
    this.gridApi?.api.forEachNode(rowNode => {
      const rowData = rowNode.data
      const assetId = rowData.assetId
      const settleDate = rowData.settleDate
      let account = rowData.accountId
      if (rowData.sleeveAccountId) {
        account = rowData.sleeveAccountId
      }
      if (account && !this.accountHplMap.has(Number(account))) {
        accountSet.add(Number(account))
      }
      const currentSecurityInputInfoTrade: SecurityInputInfoTradeKey = {
        cusip: assetId,
        settleDate: settleDate,
      }
      if (
        assetId &&
        settleDate &&
        !this.getSecurityDetailsByAssetIdAndSettleDate(
          JSON.stringify(currentSecurityInputInfoTrade),
        )
      ) {
        assetIdSettleDateMap.push({
          id: Number(rowData.rowId),
          cusip: assetId,
          date: settleDate,
          accountId: Number(account),
        })
      }
    })

    await this.loadExternalData(assetIdSettleDateMap, accountSet)

    const rowsToUpdate: BulkTradeEntryRow[] = []
    this.gridApi?.api?.forEachNode(rowNode => {
      const rowDataUnit: BulkTradeEntryRow = rowNode.data
      if (rowDataUnit.validityStatus != 'inactive') {
        const security = this.getSecurityDetailsByAssetIdAndSettleDate(
          JSON.stringify({
            cusip: rowDataUnit.assetId,
            settleDate: rowDataUnit.settleDate,
          }),
        )

        this.updateFactor(rowDataUnit, security)
        this.updateUnits(rowDataUnit)

        if (security?.securityTypeData?.isFuture) {
          rowDataUnit.dollarAccrued = '0.0'
        } else if (!this.isEdit) {
          this.calculateAndUpdateDollarAccrued(rowDataUnit, security)
        }

        const proceedValue = this.calculateProceeds(rowDataUnit, security)
        if (proceedValue.toString() !== rowDataUnit.proceeds) {
          rowDataUnit.proceeds = proceedValue.toString()
          rowsToUpdate.push(rowDataUnit)
        }
      }
    })

    this.gridApi?.api.applyTransaction({ update: rowsToUpdate })
  }

  handleCommonValidations(commonValidations: ValidationInfo[]) {
    this.genericErrors = []
    this.genericWarnings = []
    this.currentNoteError = null
    if (commonValidations.length == 0) {
      this.showConfirmButtonModal = false
    }
    commonValidations.forEach(validationInfo => {
      if (validationInfo.impactedFields.length == 0) {
        validationInfo.impactedFields = ['generic']
      }
      validationInfo.impactedFields.forEach(field => {
        if (field == 'transactionNote') {
          this.isCommonValidationError = true
          this.isDataValid = false
          const validatorKey = 'transactionNoteValidator'
          if (validationInfo.level == ErrorSeverity.ERROR) {
            this.note.markAsTouched()
            this.currentNoteError = {
              [validatorKey]: {
                message: validationInfo.message,
              },
            }
            this.note.setErrors(this.currentNoteError)
          } else if (validationInfo.level == ErrorSeverity.WARN) {
            this.noteWarning = {
              [validatorKey]: {
                message: validationInfo.message,
              },
            }
          }
        } else if (
          field == 'confirmButton' &&
          validationInfo.level == ErrorSeverity.WARN
        ) {
          this.showConfirmButtonModal = true
        } else {
          //generic case
          this.isCommonValidationError = true
          this.isDataValid = false
          if (validationInfo.level == ErrorSeverity.ERROR) {
            this.genericErrors.push(validationInfo.message)
          } else if (validationInfo.level == ErrorSeverity.WARN) {
            this.genericWarnings.push(validationInfo.message)
          }
        }
      })
    })
  }

  handleBulkValidationResponse(bulkValidationInfos: {
    [key: number]: ValidationInfo[]
  }) {
    // create errorMessages column per row and update tooltip with it

    this.gridApi?.api?.forEachNode(rowNode => {
      if (rowNode.data.validityStatus != 'inactive') {
        rowNode.data.validityStatus = 'valid'
        rowNode.data.errorMessageMap = new Map()
      }
    })

    this.note.setErrors(null)
    this.cellLevelErrorMessageMap.clear()
    this.cellLevelWarningMessageMap.clear()
    const bulkValidationInfo = new Map<string, ValidationInfo[]>(
      Object.entries(bulkValidationInfos),
    )
    bulkValidationInfo.forEach((rowValidationInfo: ValidationInfo[], index) => {
      // create a map of key index,field and keep all errors(string or string[](if erros ) and warnings (if onlky warnings)
      // in cell class rule make it yellow if warning validity status
      // in tooltip use above map to put all erros in tooltip
      const currentRowNode = this.gridApi?.api.getRowNode(index)
      const errorMessages = new Map<string, string[]>()
      const warningMessages = new Map<string, string[]>()
      rowValidationInfo.forEach((validationInfo: ValidationInfo) => {
        const isError = validationInfo.level === ErrorSeverity.ERROR
        const messageMap = isError
          ? this.cellLevelErrorMessageMap
          : this.cellLevelWarningMessageMap
        const messages = isError ? errorMessages : warningMessages
        validationInfo.impactedFields.forEach((impactedField: string) => {
          const impactedFieldProcessed = this.deduceImpactedField(impactedField)
          const currentKey = `${index}-${impactedFieldProcessed}` // More efficient key representation
          // message map
          const msgList = messageMap.get(currentKey) || []
          msgList.push(validationInfo.message)
          messageMap.set(currentKey, msgList)
          // messages
          const fieldMessages = messages.get(impactedFieldProcessed) || []
          fieldMessages.push(validationInfo.message)
          messages.set(impactedFieldProcessed, fieldMessages)
        })
      })
      if (errorMessages.size > 0 && currentRowNode) {
        this.isDataValid = false
        currentRowNode.data.validityStatus = 'invalid'
        currentRowNode.data.errorMessageMap = errorMessages
      }
      if (
        errorMessages.size == 0 &&
        warningMessages.size > 0 &&
        currentRowNode
      ) {
        currentRowNode.data.validityStatus = 'warning'
        currentRowNode.data.errorMessageMap = warningMessages
      }

      if (rowValidationInfo.length == 0 && currentRowNode) {
        currentRowNode.data.validityStatus = 'valid'
        currentRowNode.data.errorMessageMap = new Map()
      }
    })
    this.gridApi?.api.redrawRows()
  }

  createBulkValidationView(): BulkTradeEntryValidationView {
    const view: BulkTradeEntryValidationView = {
      transaction: this.getGridTransactions(true),
      requestMode: bulkRequestMode(this.transInput?.modalMode),
      reconDate: this.sessionReconDate ?? this.selectedReconDate ?? new Date(),
      tranCategory: TranCategory.TRADE,
    }
    if (this.note.value != '') view.transactionNote = this.note.value

    return view
  }

  getGridTransactions(isValidate: boolean) {
    const transactions: TransactionRequestWrapper[] = []
    this.gridApi?.api?.forEachNode(rowNode => {
      if (rowNode.data.validityStatus != 'inactive')
        transactions.push(
          this.prepareBulkTransactionData(rowNode.data, isValidate),
        )
    })
    return transactions
  }

  getGridOnlyValidTransactions(isValidate: boolean) {
    const transactions: TransactionRequestWrapper[] = []
    this.gridApi?.api?.forEachNode(rowNode => {
      if (
        rowNode.data.validityStatus == 'valid' ||
        rowNode.data.validityStatus == 'warning'
      )
        transactions.push(
          this.prepareBulkTransactionData(rowNode.data, isValidate),
        )
    })
    return transactions
  }

  prepareBulkTransactionData(
    rowData: BulkTradeEntryRow,
    isValidate: boolean,
  ): TransactionRequestWrapper {
    const security = this.getSecurityDetailsByAssetIdAndSettleDate(
      JSON.stringify({
        cusip: rowData.assetId,
        settleDate: rowData.settleDate,
      }),
    )
    let currentOriginalTransaction = undefined
    if (!isBulkCopyModal(this.transInput)) {
      currentOriginalTransaction = this.originalTransactions.find(
        origTran => origTran.legacyOrigTranId == rowData.legacyOrigTranId,
      )
    }
    const cp = this.counterPartyList.find(
      counterParty => counterParty.name == rowData.counterParty,
    )

    const transTypeCode = Object.keys(TransactionTypeEnum).filter(
      x =>
        TransactionTypeEnum[x as TransactionTypeKey] ==
        getTransactionTypeNameFromCode(rowData.tranType),
    )[0] as TransactionTypeKey
    let createdDate = new Date().toISOString()
    if (currentOriginalTransaction?.createdDate) {
      createdDate = new Date(
        currentOriginalTransaction?.createdDate,
      ).toISOString()
    }

    let account = rowData.accountId
    if (rowData.sleeveAccountId) {
      account = rowData.sleeveAccountId?.toString()
    }

    const transactionData: BulkTradeEntryTransaction = {
      commission: Number(rowData.commission),
      accrued: security
        ? Calculators.calculateAccruedInterest(
            security,
            Number(rowData.dollarAccrued),
            Number(rowData.units),
            Number(rowData.factor),
            false,
          )
        : 0.0,
      yield: currentOriginalTransaction ? currentOriginalTransaction.yield : 0,
      counterParty: cp && cp.id != -1 ? cp : getDefaultUnknownCounterParty(),
      counterPartyId:
        cp && cp.id != -1 ? cp.id : getDefaultUnknownCounterParty().id,
      postDate: rowData.postDate,
      amount: Number(rowData.proceeds),
      tranType: transTypeCode,

      amortOverrideType: currentOriginalTransaction
        ? currentOriginalTransaction.amortOverrideType
        : 'OBEY_ACCOUNT_SECURITY',
      discount: calculateDiscount(
        Number(rowData.price),
        new Date(rowData.settleDate),
        security,
      ),
      userId: this.userId ?? 0,
      accountId: Number(account),
      entryDate: rowData.entryDate,
      settleDate: rowData.settleDate,
      valuationDate: rowData.settleDate,
      dataMap: currentOriginalTransaction?.dataMap
        ? currentOriginalTransaction.dataMap
        : rowData.collateralBroker
        ? { collateralBroker: rowData.collateralBroker }
        : {},
      traderId: currentOriginalTransaction
        ? currentOriginalTransaction.traderId
        : 0,
      typeLabel: rowData.transactionTypeLabel,
    }
    if (!isValidate) {
      transactionData.revisionId = currentOriginalTransaction?.revisionId
        ? currentOriginalTransaction.revisionId + 1
        : 1
      transactionData.sourceId = TransactionConstants.HELIOS_SOURCE_ID
      transactionData.createdDate = createdDate
      transactionData.modifiedDate = new Date().toISOString()
      transactionData.active = true
    }

    if (rowData.cleared) {
      transactionData.clearedDate = isValidate
        ? new Date().toISOString().split('Z')[0]
        : new Date().toISOString()
    }

    if (rowData.price !== '') {
      transactionData.price = Number(rowData.price)
    }
    if (rowData.units !== '') {
      transactionData.units = Number(rowData.units)
    }
    if (rowData.units !== '') {
      transactionData.factor = Number(rowData.factor)
    }

    if (!isValidate) {
      transactionData.securityId = security ? security.securityMasterData.id : 0
    }
    if (rowData.inventoryType != '') {
      transactionData.inventoryType = rowData.inventoryType as InventoryType
    }
    if (rowData.tranType == 'DRAW' && transactionData.dataMap) {
      transactionData.dataMap.unfundedToFunded = true
      transactionData.typeLabelId = -1478
    }
    if (
      rowData.tranType == 'BUY' &&
      rowData.buyType == 'PIK' &&
      transactionData.dataMap
    ) {
      transactionData.dataMap.paymentInKind = true
      transactionData.typeLabelId = -1354
    }
    if (rowData.originationFee && transactionData.dataMap) {
      transactionData.dataMap.originationFee = Number(rowData.originationFee)
    }
    if (rowData.exitFee && transactionData.dataMap) {
      transactionData.dataMap.exitFee = Number(rowData.exitFee)
    }
    if (rowData.exitFeeReceivable && transactionData.dataMap) {
      transactionData.dataMap.exitFeeReceivable = Number(
        rowData.exitFeeReceivable,
      )
    }
    if (rowData.drawFee && transactionData.dataMap) {
      transactionData.dataMap.drawFee = Number(rowData.drawFee)
    }
    if (rowData.prepaymentPenaltyFee && transactionData.dataMap) {
      transactionData.dataMap.prepaymentPenaltyFee = Number(
        rowData.prepaymentPenaltyFee,
      )
    }
    if (rowData.prepaidInterest && transactionData.dataMap) {
      transactionData.dataMap.prepaidInterest = Number(rowData.prepaidInterest)
    }
    if (rowData.interestDue && transactionData.dataMap) {
      transactionData.dataMap.interestDue = Number(rowData.interestDue)
    }
    if (transactionData.dataMap) {
      Object.assign(
        transactionData.dataMap,
        getLoanFieldValues(field => rowData[field]),
      )
    }
    let unclearTransaction = false
    if (currentOriginalTransaction?.clearedDate && !rowData.cleared) {
      unclearTransaction = true
    }

    const metaData: MetaDataTransaction = {
      rowId: Number(rowData.rowId),
      reconDate: this.sessionReconDate ?? this.selectedReconDate ?? new Date(),
      cusip: rowData.assetId,
      dollarAccrued: Number(rowData.dollarAccrued),
      unclearTransaction: unclearTransaction,
      reprocessDownstreamTransfers: this.reprocessTransfers.value,
    }

    if (isBulkExternalModal(this.transInput)) {
      metaData.externalAccountId = rowData.externalAccountId
      metaData.executionId = rowData.executionId
      metaData.externalTranId = rowData.externalTranId
      metaData.externalCusip = rowData.externalCusip
      metaData.externalTranStatus = rowData.externalTranStatus
      metaData.dataSourceType = rowData.externalDataSourceType
    }

    if (currentOriginalTransaction) {
      transactionData.transactionId = currentOriginalTransaction.transactionId
      transactionData.legacyOrigTranId =
        currentOriginalTransaction.legacyOrigTranId
      transactionData.legacyTranId = currentOriginalTransaction.legacyTranId
    }
    if (!isValidate && currentOriginalTransaction?.typeLabelId) {
      transactionData.typeLabelId = currentOriginalTransaction.typeLabelId
    }
    return { transactionData, metaData }
  }

  getSecurityDetailsByAssetIdAndSettleDate(
    assetIdSettleDateKey: string,
  ): Security | undefined {
    return this.securities.get(assetIdSettleDateKey)
  }

  clearAll() {
    this.gridApi?.api.applyTransaction({
      remove: this.gridApi?.api.getRenderedNodes().map(rowNode => rowNode.data),
    })

    this.createFreshRowData()
    this.gridApi?.api.applyTransaction({ add: this.rowData })
    this.cellLevelErrorMessageMap.clear()
    this.cellLevelWarningMessageMap.clear()
    this.disableValidate = true
    this.errorDetails = ''
  }

  validateAndSave(isSaveValidRows?: boolean) {
    if (this.showConfirmButtonModal) {
      const modalRef = this.modalService.open(
        BulkTransactionsSaveConfirmationModalComponent,
        { keyboard: false },
      )
      modalRef.result.then((confirmed: boolean) => {
        if (confirmed) {
          return isSaveValidRows ? this.saveValidRows() : this.save()
        } else return
      })
    } else if (isSaveValidRows) this.saveValidRows()
    else this.save()
  }

  async saveValidRows() {
    await this.save(true)

    const newRowData: BulkTradeEntryRow[] = []
    this.gridApi?.api.forEachNode(node => {
      if (
        node.data.validityStatus != 'valid' &&
        node.data.validityStatus != 'warning'
      )
        newRowData.push(node.data)
    })

    this.gridApi?.api.setRowData(newRowData)
    this.disableSaveValidRowsButton()
  }

  async save(onlyValidRows?: boolean) {
    if (!this.isDataValid && !onlyValidRows) {
      return
    }
    this.formSubmitting = true
    this.loadingText = TransactionConstants.SAVE_TRANSACTION
    await this.blankSessionService.createBlankSessionIfNotInSession()
    const tranCommand: BulkTransactionRequest = {
      transaction: onlyValidRows
        ? this.getGridOnlyValidTransactions(false)
        : this.getGridTransactions(false),
      tranCategory: TranCategory.TRADE,
      requestMode: bulkRequestMode(this.transInput?.modalMode),
    }
    if (this.note.value != '') {
      tranCommand.transactionNote = { newValue: this.note.value }
    }
    if (isBulkEditModal(this.transInput)) {
      tranCommand.notes =
        TransactionConstants.HELIOS_BULK_TRADE_SAVE_NOTE_CW_EDIT
      this.bulkTransactionService
        .editBulkTransaction(tranCommand, TranCategoryUrl.TRADE_ENTRY)
        .pipe(takeUntil(this.destroySubject$))
        .subscribe(
          () => {
            this.toastService.success(
              'Bulk Transaction edit command successfully submitted.',
            )
            this.formSubmitting = false
            if (!onlyValidRows) this.closeModal(true, tranCommand.transaction)
          },
          error => {
            this.errorHeader = TransactionConstants.ERROR_SAVING_TRANSACTION
            this.errorDetails = error.error
            this.formSubmitting = false
          },
        )
    } else if (isBulkExternalModal(this.transInput)) {
      tranCommand.notes =
        TransactionConstants.HELIOS_BULK_TRADE_SAVE_NOTE_EXTERNAL
      this.bulkTransactionService
        .createBulkTransaction(tranCommand, TranCategoryUrl.TRADE_ENTRY)
        .pipe(takeUntil(this.destroySubject$))
        .subscribe(
          () => {
            this.toastService.success(
              'Bulk External Transaction command successfully submitted.',
            )
            this.formSubmitting = false
            if (!onlyValidRows) this.closeModal(true, tranCommand.transaction)
          },
          error => {
            this.errorHeader = TransactionConstants.ERROR_SAVING_TRANSACTION
            this.errorDetails = error.error
            this.formSubmitting = false
          },
        )
    } else {
      tranCommand.notes =
        TransactionConstants.HELIOS_BULK_TRADE_SAVE_NOTE_CW_CREATE
      this.bulkTransactionService
        .createBulkTransaction(tranCommand, TranCategoryUrl.TRADE_ENTRY)
        .pipe(takeUntil(this.destroySubject$))
        .subscribe(
          () => {
            this.toastService.success(
              'Bulk Transaction create command successfully submitted.',
            )
            this.formSubmitting = false
            if (!onlyValidRows) this.closeModal(true, tranCommand.transaction)
          },
          error => {
            this.errorHeader = TransactionConstants.ERROR_SAVING_TRANSACTION
            this.errorDetails = error.error
            this.formSubmitting = false
          },
        )
    }
  }
  generateEmptyDataEntry(activated: boolean, id: number): BulkTradeEntryRow {
    const tranTypeMap = new Map<string, string[]>()
    tranTypeMap.set('tranType', ['Valid Value Required'])
    if (activated) {
      this.missingTranRowList.add(id.toString())
    }
    return {
      rowId: id.toString(),
      accountId: '',
      tranType: '',
      entryDate: '',
      settleDate: '',
      postDate: '',
      assetId: '',
      price: '',
      units: '',
      factor: '',
      inventoryType: '',
      commission: '',
      originationFee: '',
      exitFee: '',
      exitFeeReceivable: '',
      drawFee: '',
      prepaymentPenaltyFee: '',
      prepaidInterest: '',
      interestDue: '',
      interestBearingInterestReserve: '',
      interestBearingPrincipalReserve: '',
      nonInterestBearingInterestReserve: '',
      nonInterestBearingPrincipalReserve: '',
      dollarAccrued: '',
      proceeds: '',
      counterParty: '',
      validityStatus: activated ? 'invalid' : 'inactive',
      errorMessageMap: activated ? tranTypeMap : new Map(),
      cleared: false,
      collateralBroker: '',
    }
  }

  generateDataEntryFromTrade(
    cwTransaction: BulkTradeEntryTransaction,
    index: number,
    security?: Security,
  ): BulkTradeEntryRow {
    const trade = {
      legacyOrigTranId: cwTransaction.legacyOrigTranId,
      rowId: (index + 1).toString(),
      accountId: cwTransaction.accountId.toString(),
      tranType: getTransactionTypeCodeFromKey(cwTransaction.tranType),
      entryDate: cwTransaction.entryDate,
      settleDate: cwTransaction.settleDate,
      postDate: cwTransaction.postDate,
      assetId:
        cwTransaction.cusip ??
        (security ? security.securityMasterData.cusip : ''),
      price: cwTransaction.price ? cwTransaction.price.toString() : '0.0',
      units: cwTransaction.units ? cwTransaction.units.toString() : '0.0',
      factor: cwTransaction.factor ? cwTransaction.factor.toString() : '.0',
      inventoryType: cwTransaction.inventoryType ?? '',
      commission: cwTransaction.commission
        ? cwTransaction.commission.toString()
        : '0.0',
      originationFee: cwTransaction.originationFee
        ? cwTransaction.originationFee.toString()
        : '0.0',
      exitFee: cwTransaction.exitFee ? cwTransaction.exitFee.toString() : '0.0',
      exitFeeReceivable: cwTransaction.exitFeeReceivable
        ? cwTransaction.exitFeeReceivable.toString()
        : '0.0',
      drawFee: cwTransaction.drawFee ? cwTransaction.drawFee.toString() : '0.0',
      prepaymentPenaltyFee: cwTransaction.prepaymentPenaltyFee
        ? cwTransaction.prepaymentPenaltyFee.toString()
        : '0.0',
      prepaidInterest: cwTransaction.prepaidInterest
        ? cwTransaction.prepaidInterest.toString()
        : '0.0',
      interestDue: cwTransaction.interestDue
        ? cwTransaction.interestDue.toString()
        : '0.0',
      interestBearingInterestReserve:
        cwTransaction.interestBearingInterestReserve
          ? cwTransaction.interestBearingInterestReserve.toString()
          : '0.0',
      interestBearingPrincipalReserve:
        cwTransaction.interestBearingPrincipalReserve
          ? cwTransaction.interestBearingPrincipalReserve.toString()
          : '0.0',
      nonInterestBearingInterestReserve:
        cwTransaction.nonInterestBearingInterestReserve
          ? cwTransaction.nonInterestBearingInterestReserve.toString()
          : '0.0',
      nonInterestBearingPrincipalReserve:
        cwTransaction.nonInterestBearingPrincipalReserve
          ? cwTransaction.nonInterestBearingPrincipalReserve.toString()
          : '0.0',
      dollarAccrued: security
        ? Calculators.calculateAccruedAmount(
            security,
            cwTransaction.accrued ?? 0,
            cwTransaction.units ?? 0,
            cwTransaction.factor ?? 0,
          ).toString()
        : '0.0',
      proceeds: cwTransaction.amount.toString(),
      counterParty: cwTransaction.counterParty?.name ?? 'Unknown',
      validityStatus: 'intermediate',
      errorMessageMap: new Map(),
      cleared: cwTransaction.clearedDate ? true : false,
      collateralBroker: cwTransaction.dataMap?.collateralBroker ?? '',
    } as BulkTradeEntryRow
    if (cwTransaction.orderId) trade.orderId = cwTransaction.orderId
    return trade
  }

  generateDataEntryFromExternalTrade(
    extTransaction: ExternalTransaction,
    index: number,
  ): BulkTradeEntryRow {
    let accountId = extTransaction.accountId.toString()
    if ('CUSTODY' === extTransaction.dataSourceType) {
      if (this.hideAccountForSleeveAggregate(extTransaction.accountId)) {
        accountId = ''
      }
    }

    const externalTrade = {
      rowId: (index + 1).toString(),
      accountId: accountId.toString(),
      tranType: extTransaction.tranTypeCode
        ? getTransactionTypeCodeFromKey(
            extTransaction.tranTypeCode as TransactionTypeKey,
          )
        : '',
      entryDate: extTransaction.tradeDate ?? '',
      settleDate: extTransaction.settleDate ?? '',
      postDate: extTransaction.postDate ?? '',
      assetId: extTransaction.secIdentifier ?? '',
      cleared:
        this.isDateBeforeCurrentReconDate(extTransaction.postDate) ?? false,
      price: extTransaction.price ? extTransaction.price.toString() : '0.0',
      units: extTransaction.units,
      factor: extTransaction.factor ? extTransaction.factor.toString() : '',
      inventoryType: extTransaction.inventoryType ?? '',

      commission: extTransaction.commission
        ? extTransaction.commission.toString()
        : '0.0',
      originationFee: extTransaction.originationFee?.toString()
        ? extTransaction.originationFee?.toString()
        : '0.0',
      exitFee: extTransaction.exitFee?.toString()
        ? extTransaction.exitFee.toString()
        : '0.0',
      exitFeeReceivable: extTransaction.exitFeeReceivable?.toString()
        ? extTransaction.exitFeeReceivable.toString()
        : '0.0',
      drawFee: extTransaction.drawFee?.toString()
        ? extTransaction.drawFee.toString()
        : '0.0',
      prepaymentPenaltyFee: extTransaction.prepaymentPenaltyFee?.toString()
        ? extTransaction.prepaymentPenaltyFee.toString()
        : '0.0',
      prepaidInterest: extTransaction.prepaidInterest?.toString()
        ? extTransaction.prepaidInterest?.toString()
        : '0.0',
      interestDue: extTransaction.interestDue?.toString()
        ? extTransaction.interestDue?.toString()
        : '0.0',
      interestBearingInterestReserve:
        extTransaction.interestBearingInterestReserve?.toString()
          ? extTransaction.interestBearingInterestReserve.toString()
          : '0.0',
      interestBearingPrincipalReserve:
        extTransaction.interestBearingPrincipalReserve?.toString()
          ? extTransaction.interestBearingPrincipalReserve.toString()
          : '0.0',
      nonInterestBearingInterestReserve:
        extTransaction.nonInterestBearingInterestReserve?.toString()
          ? extTransaction.nonInterestBearingInterestReserve.toString()
          : '0.0',
      nonInterestBearingPrincipalReserve:
        extTransaction.nonInterestBearingPrincipalReserve?.toString()
          ? extTransaction.nonInterestBearingPrincipalReserve.toString()
          : '0.0',
      dollarAccrued: extTransaction.accrued
        ? extTransaction.accrued.toString()
        : '0.0',
      proceeds: extTransaction.amount ? extTransaction.amount.toString() : 0.0,
      counterParty: extTransaction.clearwaterCounterParty?.name ?? 'Unknown',
      validityStatus: 'intermediate',
      errorMessageMap: new Map(),
      executionId: extTransaction.executionId,
      externalTranId: extTransaction.extTranId,
      externalAccountId: extTransaction.accountId,
      externalCusip: extTransaction.secIdentifier,
      externalTranStatus: extTransaction.status,
      externalDataSourceType: extTransaction.dataSourceType,
      collateralBroker:
        extTransaction.collateralBroker ??
        extTransaction.prometheusJson.aggInfo?.collateralBroker ??
        '',
      transactionTypeLabel: extTransaction.transactionTypeLabel,
    } as BulkTradeEntryRow

    if (!extTransaction.tranTypeCode) {
      const tranTypeMap = new Map<string, string[]>()
      tranTypeMap.set('tranType', ['Valid Value Required'])
      this.missingTranRowList.add((index + 1).toString())
      this.disableValidate = true
      externalTrade.validityStatus = 'invalid'
      externalTrade.errorMessageMap = tranTypeMap
    }

    return externalTrade
  }
  createFreshRowData() {
    this.rowData = []
    this.rowData.push(this.generateEmptyDataEntry(true, 1))
    for (let i = 1; i <= 9; i++) {
      this.rowData.push(this.generateEmptyDataEntry(false, i + 1))
    }
  }

  isDateBeforeCurrentReconDate(date: string | undefined) {
    if (
      this.reconDate &&
      !isAfter(parseDate(date, ISODateFormat), this.reconDate)
    )
      return true
    return false
  }

  private closeModal(
    success: boolean,
    transactionRequests: TransactionRequestWrapper[],
  ): void {
    this.activeModal.close({
      success,
      transactionRequests,
    } as BulkTransactionModalResponse)
  }

  async loadExtTransactionDetailBulk(transInput: number[]) {
    const sessionAccountId = await this.store
      .select(selectFirstLoadedAccountId)
      .pipe(take(1))
      .toPromise()
    const transactionDetail$: Observable<ExternalUnmatchedTransaction[]> =
      this.bulkTransactionService.loadExtTransactionDetailBulk(
        transInput,
        sessionAccountId,
      )
    const accountInfo$ = this.store
      .select(selectFirstFocusedAccountInfo)
      .pipe(take(1))
    return Promise.all([
      transactionDetail$.toPromise(),
      accountInfo$.toPromise(),
    ]).then(async ([extTransactionDetail, accountInfo]) => {
      if (this.transInput) {
        // Create a Map with the transaction details keyed by their id for faster lookup
        const transactionDetailById = new Map(
          extTransactionDetail.map(td => [td.externalTransactionId, td]),
        )
        // Sort the transaction details based on the order of transInput
        this.bulkExternalTransactionDetail = transInput
          .map(id => transactionDetailById.get(id))
          .filter((td): td is ExternalUnmatchedTransaction => Boolean(td))
        await this.setSessionAccounInfo(accountInfo)
      }
    })
  }
  async loadTransactionDetailBulk(
    cwTransId: string[],
    securityData: SecurityIdRequest[] | undefined,
  ) {
    const transactionDetail$: Observable<ClearwaterTransactionDetailResponse> =
      this.bulkTransactionService.loadTransactionDetailBulkV2(
        cwTransId,
        securityData,
        TranCategoryUrl.TRADE_ENTRY,
      )
    return Promise.all([transactionDetail$.toPromise()]).then(
      ([transactionDetail]) => {
        const unorderedTransactionDetails = transactionDetail.transactionDataMap
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const orderedTransactionDetails: { [key: string]: any } = {}

        // Sort the transaction details based on the order of cwTransid
        for (const id of cwTransId) {
          if (unorderedTransactionDetails[id]) {
            orderedTransactionDetails[id] = unorderedTransactionDetails[id]
          }
        }

        this.clearwaterTransactionDetail = orderedTransactionDetails
        new Map<string, Security>(
          Object.entries(transactionDetail.securityData ?? ''),
        ).forEach((securityResponse, rowId) => {
          const securityDataCurrent = securityData?.find(
            secData => secData.id == Number(rowId),
          )

          if (securityDataCurrent) {
            this.securities.set(
              JSON.stringify({
                cusip: securityResponse.securityMasterData.cusip,
                settleDate: securityDataCurrent.date,
              }),
              securityResponse,
            )
            this.editSecurityIdToCusipMap.set(
              securityResponse.securityMasterData.id,
              securityResponse.securityMasterData.cusip,
            )
          }
        })
      },
    )
  }

  disableGridFocus() {
    this.gridApi?.api.clearRangeSelection()
  }

  async loadNonSessionAccountTypeInfo(
    uniqueAccountId: number[],
  ): Promise<void> {
    const accountInfoPromise = this.bulkTransactionService
      .fetchAccountTypes(uniqueAccountId)
      .toPromise()
    await Promise.all([accountInfoPromise]).then(async accountTypeObj => {
      if (!accountTypeObj) return
      this.sleeveSimpleAccount = Object.entries(accountTypeObj[0])
        .map(([key, value]) => {
          return {
            id: Number(key),
            type: value,
          }
        })
        .filter(data => data.type === 'sleeveAggregate')

      if (this.sleeveSimpleAccount.length > 0) {
        this.sleeveAccountIds = this.sleeveSimpleAccount.map(({ id }) => id)

        const subAccounts = await this.bulkTransactionService
          .fetchAllSubAccounts(this.sleeveAccountIds)
          .toPromise()

        if (!subAccounts) return

        this.bulkSleeveSimpleAccount = Object.entries(subAccounts).map(
          ([key, value]) => {
            return {
              id: Number(key),
              sleeveSimple: value,
            }
          },
        )
      }
    })
  }

  isAccountEditable(params: EditableCallbackParams): boolean {
    if (
      'sleeveAggregate' === this.sessionAccountInfo?.accountType ||
      this.transInput?.externalTransaction
    ) {
      if ('sleeveAggregate' === this.sessionAccountInfo?.accountType) {
        return this.isSessionAccountEditable()
      } else {
        return this.isNonSessionAccountsEditable(params)
      }
    } else if (!this.isEdit) {
      return true
    }
    return false
  }

  isSessionAccountEditable() {
    return true
  }

  isNonSessionAccountsEditable(params: EditableCallbackParams) {
    if (this.sleeveAccountIds?.includes(params.data['externalAccountId'])) {
      return true
    }
    return false
  }

  async setSessionAccounInfo(accountInfo?: AccountInfo) {
    if (accountInfo) {
      this.sessionAccountInfo = accountInfo
      if ('sleeveAggregate' === accountInfo.accountType) {
        const subAccounts = await this.bulkTransactionService
          .fetchSubAccounts(accountInfo.accountId)
          .toPromise()
        this.sleeveSimpleAccount = subAccounts
      }
    }
  }
  hideAccountForSleeveAggregate(accountId: number) {
    if (
      'sleeveAggregate' === this.sessionAccountInfo?.accountType &&
      this.sessionAccountInfo?.accountId == accountId
    ) {
      return true
    } else if (this.sleeveAccountIds?.includes(accountId)) {
      return true
    }
    return false
  }

  @HostListener('click') dialogClicked() {
    if (isDialogComponentInActive(this.compId)) {
      activateDialog(this.activeInstances, this.compId, this.elRef)
    }
  }

  getComponentId() {
    return this.compId
  }

  copyHeaders() {
    const headers = this.gridApi?.columnApi
      .getAllDisplayedColumns()
      .filter(col => col.getColId() !== 'validityStatus')
      .map(col => col.getColDef().headerName)
    let headersTabSeparated = ''
    if (headers) headersTabSeparated = headers.join('\t')

    navigator.clipboard.writeText(headersTabSeparated)
    this.toastService.success('Copied to Clipboard')
  }
}
